import script from "./LegalDocumentsList.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalDocumentsList.vue?vue&type=script&setup=true&lang=js"

import "./LegalDocumentsList.vue?vue&type=style&index=0&id=00ea6650&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00ea6650"]])

export default __exports__